// extracted by mini-css-extract-plugin
export default {"comment":"CommentGroup_comment__kr+m4","commentArea":"CommentGroup_commentArea__VbU2L","yellow":"CommentGroup_yellow__pRFmp"};